import { render, staticRenderFns } from "./Descarga.vue?vue&type=template&id=e36e6216&"
import script from "./Descarga.vue?vue&type=script&lang=ts&"
export * from "./Descarga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports